/**
 * Élément à focus dans un conteneur de champ lors d'un saut d'erreur
 * (`scrollToField`). On privilégie STRICTEMENT le contrôle de saisie
 * (`input` / `textarea` / `select`) et on ne retombe sur un `button` ou un
 * `[tabindex]` focusable que s'il n'existe aucun contrôle de saisie.
 *
 * Pourquoi : un conteneur de champ peut contenir, AVANT son `<input>`, un
 * bouton décoratif — par exemple l'affordance d'aide « ? » de `<FieldHelp>`.
 * Un simple `querySelector("input, …, button, …")` renvoie le premier match
 * dans l'ordre du DOM, donc ce bouton d'aide volerait le focus au lieu du champ
 * que l'utilisateur doit corriger (régression a11y du saut sur collision de
 * code, §B2 : « focus + ring sur le champ Code »).
 *
 * Renvoie `null` (frontière DOM, testé immédiatement par l'appelant) si le
 * conteneur n'a aucun élément focusable au clavier.
 */
export function firstFocusableControl(container: HTMLElement): HTMLElement | null {
  const control = container.querySelector<HTMLElement>("input, textarea, select")
  if (control) {
    return control
  }
  return container.querySelector<HTMLElement>(
    "button, [tabindex]:not([tabindex='-1'])",
  )
}
